import React from 'react';

class SMHomeHostMainBannerView extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="top-static__banner">
        <div className="container">
          <h3 className="top-static__banner-title">あなたもホストになってみませんか</h3>
          <p className="top-static__banner-text">お持ちのスペースを今すぐ有効活用。あらゆるスペースが登録可能です。</p>
          <a href={Routes.page_path('host_entry')} className="button-blue top-static__banner-button">{I18n.t('service.label_000008')}</a>
        </div>
      </div>
    );
  }
}
export default SMHomeHostMainBannerView;



// WEBPACK FOOTER //
// ./app/javascript/components/home/SMHomeHostMainBannerView.jsx